<section>
    <div class="container" style="width: 100%;">
        <p> <i (click)="back()" class="fa fa-arrow-left" aria-hidden="true"></i> Back </p>
        <div class="row" style="padding: 0px 0px 23px 10px;">
            <div class="card-box">
                <div class="row" style="padding: 0px 0px 23px 10px;">
                    <div class="col-md-4">
                        <h5 class="form-lable">Existing or New:</h5>

                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Account Type:</h5>

                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Set Primary:</h5>

                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Primary Account:</h5>

                    </div>
                </div>
            </div>

            <div class="card-box">
                <div class="row" style="padding: 0px 0px 23px 10px;">
                    <div class="col-md-4">
                        <h5 class="form-lable">No.of License:</h5>
                        <input type="text" pInputText [(ngModel)]="License" placeholder="No.of License">
                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Client Type:</h5>


                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Country:</h5>


                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Client short code:</h5>
                        <input type="text" pInputText [(ngModel)]="Short_code" placeholder="Client short code">
                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Client system code:</h5>
                        <input type="text" pInputText [(ngModel)]="System_code" placeholder="Client system code">
                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Client Name:</h5>
                        <input type="text" pInputText [(ngModel)]="Name" placeholder="Client Name">
                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Website:</h5>
                        <input type="text" pInputText [(ngModel)]="Website" placeholder="Website">
                    </div>
                    <div class="col-md-4">
                        <h5 class="form-lable">Common email id:</h5>
                        <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="email_id" pInputText
                            placeholder="Common email id" style="width:80%">

                    </div>
                    <!-- <div class="col-md-4">
                        <h5 class="form-lable">Password:</h5>
                        <input type="text" pInputText [(ngModel)]="Name" placeholder="Password">
                    </div> -->
                    <div class="col-md-4">
                        <h5 class="form-lable">Logo:</h5>
                        <img *ngIf="logo != undefined" src="{{logo}}" alt=""
                            style="width: 40px;height: 40px;float: right;margin-top: -37px;" />

                    </div>
                    <div class="col-md-6">
                        <h5 class="form-lable">Ho Address:</h5>
                        <textarea rows="3" cols="30" pInputTextarea [(ngModel)]="Ho_Address"></textarea>
                    </div>
                    <div class="col-md-6">
                        <h5 class="form-lable">Office Address:</h5>
                        <textarea rows="3" cols="30" pInputTextarea [(ngModel)]="Office_Address"></textarea>
                    </div>



                    <!-- <div class="col-md-12 mt-20">
                        <button *ngIf="id == undefined" type="button" class="btn btn-primary"
                            (click)="create()">Create</button>
                        <button *ngIf="id != undefined" type="button" class="btn btn-primary"
                            (click)="update()">Update</button>
                    </div> -->

                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-md-12" style="margin-top: 25px;">
                <div class="spec">
                    <h5>Client Representative / Contact Persons:</h5>

                </div>
                <div class="col-md-12 mt-20">

                    <div class="card-box">
                        <p-table [value]="ref_persons_array" styleClass="ui-table-customers" #tt [paginator]="true"
                            [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [globalFilterFields]="['type']">

                            <ng-template pTemplate="header">
                                <tr class="thhead">
                                    <th>S.No</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone No</th>
                                    <th>WhatsApp No</th>
                                    <th>Landline</th>
                                    <th>Extension</th>
                                    <th>Staff no</th>
                                    <th>Internal ID card no</th>
                                    <th>Designation</th>
                                    <th>Reporting to</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-i="rowIndex">
                                <tr class="tdrow">
                                    <td>{{i+1}}</td>
                                    <td>{{item.ref_name}}</td>
                                    <td>{{item.ref_email}}</td>
                                    <td>{{item.ref_pone}}</td>
                                    <td>{{item.ref_whats_pone}}</td>
                                    <td>{{item.ref_lanline}}</td>
                                    <td>{{item.ref_extension}}</td>
                                    <td>{{item.ref_Staff_no}}</td>
                                    <td>{{item.ref_Internal_ID}}</td>
                                    <td>{{item.ref_Designation}}</td>
                                    <td>{{item.ref_Reporting_to.y}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>


                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-md-12" style="margin-top: 25px;">
                <div class="spec">
                    <h5>Documents</h5>

                </div>
                <div class="col-md-12 mt-20">

                    <div class="card-box">
                        <p-table [value]="Documents_array" styleClass="ui-table-customers" #tt [paginator]="true"
                            [rows]="5" [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [globalFilterFields]="['type']">

                            <ng-template pTemplate="header">
                                <tr class="thhead">
                                    <th>S.No</th>
                                    <th>Document Type</th>
                                    <th>Document Name</th>
                                    <th>Attachment</th>
                                    <th>Start date</th>
                                    <th>End date</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-i="rowIndex">
                                <tr class="tdrow">
                                    <td>{{i+1}}</td>
                                    <td>{{item.Document_Type}}</td>
                                    <td>{{item.Document_Name}}</td>
                                    <td>
                                        <i (click)="goToLink1(item.Document_link)" class="fa fa-file-text"
                                            style="background-color: #fff;color: #fd2c3a;" aria-hidden="true"></i>

                                    </td>
                                    <td>{{item.Start_date}}</td>
                                    <td>{{item.End_date}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-md-12" style="margin-top: 25px;">
                <div class="spec">
                    <h5>Account Details</h5>

                </div>
                <div class="card-box">
                    <p-table [value]="Account_array" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
                        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [globalFilterFields]="['type']">

                        <ng-template pTemplate="header">
                            <tr class="thhead">
                                <th>S.No</th>
                                <th>Account No</th>
                                <th>IFSC Code</th>
                                <th>IBAN No</th>
                                <th>Bank Name</th>
                                <th>Branch</th>
                                <th>Address of the bank</th>
                                <th>Country</th>
                                <th>Currency</th>
                                <th>Swift Code</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            <tr class="tdrow">
                                <td>{{i+1}}</td>
                                <td>{{item.Account_No}}</td>
                                <td>{{item.IFSC}}</td>
                                <td>{{item.IBAN}}</td>
                                <td>{{item.Bank_Name}}</td>
                                <td>{{item.Branch}}</td>
                                <td>{{item.Bank_address}}</td>
                                <td>{{item.Bnak_Country}}</td>
                                <td>{{item.Bank_Currency}}</td>
                                <td>{{item.Swift_Code}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

            </div>

        </div>
    </div>
</section>